import AppConstants from '../constants/AppConstants';
import store from '../stores/redux';
import api from '../api';
import handleError from '../helpers/requestErrorHandler';

const { dispatch } = store;
const defEventsGoals = {
    before: AppConstants.GOALS_SEARCH_START_LOADING,
    success: AppConstants.GOALS_SEARCH_SUCCESS,
    fail: AppConstants.GOALS_SEARCH_FAIL
};

const defEventsAdvertisers = {
    before: AppConstants.ADVERTISERS_SEARCH_LOADING_START,
    success: AppConstants.ADVERTISERS_SEARCH_SUCCESS,
    fail: AppConstants.ADVERTISERS_SEARCH_FAIL
};

const defEventsPeriods = {
    before: AppConstants.PERIODS_SEARCH_LOADING_START,
    success: AppConstants.PERIODS_SEARCH_SUCCESS,
    fail: AppConstants.PERIODS_SEARCH_FAIL
};

const defEventsOffers = {
    before: AppConstants.OFFERS_SEARCH_START_LOADING,
    success: AppConstants.OFFERS_SEARCH_SUCCESS,
    fail: AppConstants.OFFERS_SEARCH_FAIL
};

const defEventsConversion = {
    before: AppConstants.CONVERSION_SEARCH_START_LOADING,
    success: AppConstants.CONVERSION_SEARCH_SUCCESS
};

const defEventsFinanceOperation = {
    before: AppConstants.FINANCE_OPERATION_SEARCH_START_LOADING,
    success: AppConstants.FINANCE_OPERATION_SEARCH_SUCCESS
};

const defEventsPaymentDetails = {
    before: AppConstants.PAYMENT_DETAILS_SEARCH_START_LOADING,
    success: AppConstants.PAYMENT_DETAILS_SEARCH_SUCCESS,
};

const AdvertiserActions = {
    getGoalEntries(params, callback) {
        dispatch({
            type  : AppConstants.GOAL_ENTRIES_SEARCH_LOADING_START
        });

        return api.searchGoalEntries(params)
            .then(data => {
                dispatch({
                    type  : AppConstants.GOAL_ENTRIES_SEARCH_SUCCESS,
                    items : data.response || {}
                });

                callback && callback();
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: AppConstants.GOAL_ENTRIES_SEARCH_FAIL,
                        error: err
                    });
                });
            });

    },

    getAccountEntries(params) {
        dispatch({
            type  : AppConstants.ACCOUNT_ENTRIES_START_LOADING
        });

        return api.searchAccountEntries(params)
            .then(data => {
                dispatch({
                    type  : AppConstants.ACCOUNT_ENTRIES_SEARCH_SUCCESS,
                    items : data.response || {}
                });
            })
            .catch(err => {
                handleError(err);
            });
    },
};

export default AdvertiserActions;
